import React, { useEffect, useState } from "react";
import "./App.css";
import {
  Switch,
  Route,
  Redirect,
  useHistory,
  useLocation,
  BrowserRouter as Router,
} from "react-router-dom";
import { Blank } from "./views/Blank/Blank";
import { ConnectModal } from "./views/ConnectModal/ConnectModal";

function App() {
  const navigate = useHistory();

  const [status, setStatus] = useState<
    "splash" | "email" | "verify" | "purchase" | "walletReady" | "close"
  >("splash");

  // const handleChange = React.useCallback((newValue:any) => {
  //   console.log("Badk", newValue)
  //   setStatus(newValue);
  // }, []);

  const updateParentState = (
    newState:
      | "splash"
      | "email"
      | "verify"
      | "purchase"
      | "walletReady"
      | "close"
  ) => {
    setStatus(newState);
  };

  useEffect(() => {
    if (status === "close") {
      navigate.push(`/`);
    }
  }, [status]);

  return (
    <Router>
      <Switch>
        <Route path={`/splash`}>
          {status !== "close" && (
            <ConnectModal
              step={status}
              updateParentState={updateParentState}
              fullView={false}
            ></ConnectModal>
          )}
        </Route>
        
        
        <Route path={`/`}>
          <Blank></Blank>
        </Route>
        <Redirect to={`/`} />
      </Switch>
    </Router>
  );
}

export default App;
